import PropTypes from 'prop-types';
import React from 'react';
import { IconComponent } from 'types/base';
import { CheckboxWrapper, Input, Label } from './checkbox.styles';

interface Props extends React.HTMLProps<HTMLInputElement> {
  label: string;
  id: string;
  icon?: IconComponent;
  type?: 'checkbox' | 'radio';
  align?: 'top' | 'center';
  slim?: boolean;
  bold?: boolean;
}

const Checkbox = React.forwardRef<HTMLInputElement, Props>(
  (
    { id, label, icon: CustomIcon, type, align, slim, bold, ...inputProps },
    forwardedRef
  ) => {
    const Icon: IconComponent = (props) =>
      CustomIcon ? <CustomIcon {...props} /> : null;

    return (
      <CheckboxWrapper slim={slim}>
        <Input
          type={type}
          id={id}
          ref={forwardedRef}
          {...(inputProps as any)}
        />
        <Label htmlFor={id} align={align} slim={slim} bold={bold}>
          <Icon width='40' aria-hidden role='presentation' />
          {label}
        </Label>
      </CheckboxWrapper>
    );
  }
);

Checkbox.defaultProps = {
  type: 'checkbox',
  align: 'center',
};

Checkbox.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['checkbox', 'radio']),
  align: PropTypes.oneOf(['top', 'center']),
};

export default Checkbox;
